import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'react-router';

import { GlobalState } from 'ha/types/store';

import {
  getNumberOfListings,
  getLocation,
  getAdvertiserName,
} from '../selectors';
import SearchAdvertiserTitle from '../components/SearchAdvertiserTitle';

const enhance = compose(
  withRouter,
  connect((state: GlobalState) => ({
    total: getNumberOfListings(state),
    placeName: getLocation(state),
    advertiserName: getAdvertiserName(state),
  })),
);

export default enhance(SearchAdvertiserTitle);
